import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type WholesaleProductElementImageFragment = { id: string, image: string, sortOrder: number, width: number, height: number, thumbnail: string | null };

export type WholesaleProductElementFragment = { id: string, name: string, slug: string, sortOrder: number, description: string };

export const WholesaleProductElementImageFragmentDoc = gql`
    fragment WholesaleProductElementImageFragment on WholesaleProductElementImageType {
  id
  thumbnail: thumbnailUrl(method: THUMBNAIL_WEBP, size: "600x0")
  image
  sortOrder
  width
  height
}
    `;
export const WholesaleProductElementFragmentDoc = gql`
    fragment WholesaleProductElementFragment on WholesaleProductElementType {
  id
  name
  slug
  sortOrder
  description
}
    `;